/* Valise Cabine — interactions du thème (panier Shopify, fiche produit, cartes) */
(function () {
  'use strict';
  var $ = function (id) { return document.getElementById(id); };
  var R = (window.VC && window.VC.routes) || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  var eur = function (cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var shortTitle = function (t) { return String(t || '').split(' – ')[0]; };

  /* ---------- Message éphémère ---------- */
  var tt;
  function say(msg) {
    var t = $('toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(tt); tt = setTimeout(function () { t.classList.remove('on'); }, 2400);
  }

  /* ---------- Panier latéral ---------- */
  var panel, scrim;
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }
  function getCart() {
    return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function renderCart(cart) {
    var pb = $('pbody'), pf = $('pfoot'); if (!pb) return;
    setCount(cart.item_count);
    if (!cart.items.length) {
      pb.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24" width="42" height="42" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 8h14l-1.2 12H6.2z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><p style="margin:0">Votre panier est vide.</p><a class="btn" href="/collections/all">Découvrir les valises</a></div>';
      pf.innerHTML = '';
      return;
    }
    pb.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="m">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="line">' + (img ? '<img class="ph-img" src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
        '<div><b><a href="' + esc(it.url) + '">' + esc(shortTitle(it.product_title)) + '</a></b>' + variant + '<br>' +
        '<span class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Retirer un article">−</button><span>' + it.quantity + '</span>' +
        '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Ajouter un article">+</button></span>' +
        '<button type="button" class="rm" data-line="' + (i + 1) + '" data-q="0">Retirer</button></div>' +
        '<span class="lp">' + eur(it.final_line_price) + '</span></div>';
    }).join('');
    pf.innerHTML =
      '<div class="sum"><span>Sous-total</span><span>' + eur(cart.total_price) + '</span></div>' +
      '<div class="sum"><span>Livraison (France, 3 à 5 jours ouvrés)</span><span class="free">Offerte</span></div>' +
      '<div class="sum t"><span>Total TTC</span><span>' + eur(cart.total_price) + '</span></div>' +
      '<a class="btn" href="/checkout">Commander</a>' +
      '<a class="btn ghost" href="' + R.cart + '">Voir le panier</a>' +
      '<span class="secure">🔒 Paiement sécurisé</span>';
    pb.querySelectorAll('[data-line]').forEach(function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch(R.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) })
        }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { say('La mise à jour du panier a échoué, réessayez.'); b.disabled = false; });
      });
    });
  }
  function openCart() {
    if (!panel) return;
    getCart().then(renderCart);
    scrim.hidden = false;
    requestAnimationFrame(function () { scrim.classList.add('on'); panel.classList.add('on'); });
    panel.setAttribute('aria-hidden', 'false');
    var bb = $('buybar'); if (bb) bb.classList.remove('on');
    setTimeout(function () { var c = $('pclose'); if (c) c.focus(); }, 300);
  }
  function closeCart() {
    if (!panel) return;
    scrim.classList.remove('on'); panel.classList.remove('on'); panel.setAttribute('aria-hidden', 'true');
    setTimeout(function () { scrim.hidden = true; }, 250);
    if (window.VC_updateBar) window.VC_updateBar();
  }
  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch(R.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Ajout impossible');
        return data;
      });
    }).finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }

  /* ---------- Cartes produit : changement de coloris ---------- */
  function initCards(root) {
    (root || document).querySelectorAll('[data-card]').forEach(function (card) {
      var img = card.querySelector('.img img');
      card.querySelectorAll('.dots button').forEach(function (b) {
        b.addEventListener('click', function () {
          card.querySelectorAll('.dots button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          var cn = card.querySelector('.cn');
          if (cn) { var m = /^(\+\d+ · )/.exec(cn.textContent); cn.textContent = (m ? m[1] : '') + b.dataset.name; }
          if (img && b.dataset.img) { img.removeAttribute('srcset'); img.src = b.dataset.img; }
        });
      });
    });
  }

  /* ---------- Héros de l'accueil ---------- */
  function initHero() {
    var hero = document.querySelector('[data-hero]'); if (!hero) return;
    var photo = hero.querySelector('.ph-photo'), input = hero.querySelector('[data-hero-variant]');
    hero.querySelectorAll('.sw').forEach(function (b) {
      b.addEventListener('click', function () {
        hero.querySelectorAll('.sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        hero.querySelectorAll('[data-hero-color]').forEach(function (el) { el.textContent = b.dataset.name; });
        var pr = hero.querySelector('[data-hero-price]'); if (pr) pr.textContent = b.dataset.price;
        if (input) input.value = b.dataset.variant;
        var btn = hero.querySelector('[data-add-form] button[type=submit]');
        if (btn) btn.disabled = b.dataset.unavailable === 'true';
        if (photo && b.dataset.img) { photo.style.opacity = 0; setTimeout(function () { photo.removeAttribute('srcset'); photo.src = b.dataset.img; photo.style.opacity = 1; }, 160); }
      });
    });
  }

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    var dataEl = $('pjson'); if (!dataEl) return;
    var P = JSON.parse(dataEl.textContent);
    var V = P.variants;
    var form = $('pform'), vid = $('vid');
    var current = V.filter(function (v) { return String(v.id) === String(vid.value); })[0] || V[0];
    var sel = current.options.slice();
    var colorIdx = P.colorIndex;
    var lastIdx = 0;

    function find(opts) {
      return V.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function detail(val) { var m = /\(([^)]+)\)/.exec(val); return m ? m[1].replace(/ x /g, ' × ') : val; }
    function draw() {
      var v = find(sel);
      if (!v) { v = V.filter(function (x) { return x.options[lastIdx] === sel[lastIdx] && x.available; })[0] || V.filter(function (x) { return x.options[lastIdx] === sel[lastIdx]; })[0] || V[0]; sel = v.options.slice(); }
      current = v; vid.value = v.id;
      $('pp').textContent = eur(v.price);
      var po = $('po'), ps = $('ps');
      if (v.compare > v.price) { po.textContent = eur(v.compare); ps.hidden = false; ps.textContent = 'Économisez ' + eur(v.compare - v.price); }
      else { po.textContent = ''; ps.hidden = true; }
      document.querySelectorAll('[data-optlabel]').forEach(function (el) {
        var i = +el.dataset.optlabel; el.textContent = i === colorIdx ? sel[i] : detail(sel[i]);
      });
      var fmtIdx = -1;
      sel.forEach(function (o, i) { if (i !== colorIdx) fmtIdx = i; });
      var eb = $('eb');
      if (eb) eb.textContent = fmtIdx > -1 ? sel[fmtIdx].split(' (')[0] + (sel[fmtIdx].indexOf('(') > -1 ? ' · ' + detail(sel[fmtIdx]) : '') : '';
      document.querySelectorAll('[data-opt]').forEach(function (b) {
        var i = +b.dataset.opt, val = b.dataset.val;
        b.setAttribute('aria-pressed', String(val === sel[i]));
        var test = sel.slice(); test[i] = val;
        var tv = find(test);
        b.dataset.unavailable = String(!tv || !tv.available);
        var em = b.querySelector('[data-pill-price]');
        if (em) em.textContent = tv ? eur(tv.price) : '—';
      });
      var low = v.tracked && v.qty > 0 && v.qty < 10;
      var st = $('stock'); st.classList.toggle('low', low);
      st.querySelector('span').textContent = !v.available ? 'Épuisé pour le moment' : (low ? 'Stock limité · expédiée sous 3 à 5 jours ouvrés' : 'En stock · expédiée sous 3 à 5 jours ouvrés');
      var add = $('add'), bn = $('buynow'), bba = $('bbadd');
      [add, bn, bba].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (add) add.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (v.img) {
        var g = $('gmain');
        if (g && g.dataset.src !== v.img) { g.removeAttribute('srcset'); g.src = v.img; g.dataset.src = v.img; }
        document.querySelectorAll('#thumbs button').forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.id === String(v.imgId))); });
        var bi = $('bbimg'); if (bi && v.thumb) { bi.removeAttribute('srcset'); bi.src = v.thumb; }
      }
      var bc = $('bbcol'); if (bc) bc.textContent = v.options.join(' / ') + ' · Livraison offerte';
      var bp = $('bbpr'); if (bp) bp.textContent = eur(v.price);
      try { var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url); } catch (e) {}
    }
    document.querySelectorAll('[data-opt]').forEach(function (b) {
      b.addEventListener('click', function () { lastIdx = +b.dataset.opt; sel[lastIdx] = b.dataset.val; draw(); });
    });
    document.querySelectorAll('#thumbs button').forEach(function (t) {
      t.addEventListener('click', function () {
        var g = $('gmain'); if (!g) return;
        g.removeAttribute('srcset'); g.src = t.dataset.src; g.dataset.src = t.dataset.src;
        document.querySelectorAll('#thumbs button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
      });
    });
    var err = $('perr');
    function doAdd(btn, thenCheckout) {
      if (err) err.hidden = true;
      return addToCart(current.id, 1, btn).then(function () {
        if (thenCheckout) { location.href = '/checkout'; return; }
        say(P.title + ' · ' + current.options.join(' / ') + ' ajouté au panier');
        openCart();
      }).catch(function (e) {
        if (err) { err.hidden = false; err.textContent = e.message || 'Ajout impossible, réessayez.'; }
        say('Ajout impossible : ' + (e.message || 'réessayez.'));
      });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); doAdd($('add'), false); });
    var bn = $('buynow'); if (bn) bn.addEventListener('click', function () { doAdd(bn, true); });
    var bba = $('bbadd'); if (bba) bba.addEventListener('click', function () { doAdd(bba, false); });
    var bar = $('buybar'), vis = true;
    window.VC_updateBar = function () { if (!bar) return; if (panel && panel.classList.contains('on')) return; bar.classList.toggle('on', !vis); };
    if ('IntersectionObserver' in window && $('add')) {
      new IntersectionObserver(function (es) { vis = es[0].isIntersecting; window.VC_updateBar(); }).observe($('add'));
    }
    draw();
  }

  /* ---------- Formulaires d'ajout rapide (héros, duo) ---------- */
  function initAddForms() {
    document.querySelectorAll('form[data-add-form]').forEach(function (f) {
      if (f.id === 'pform') return;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = f.querySelector('[name=id]').value, btn = f.querySelector('[type=submit]');
        addToCart(id, 1, btn).then(function () { say('Ajouté au panier'); openCart(); })
          .catch(function (er) { say('Ajout impossible : ' + (er.message || 'réessayez.')); });
      });
    });
  }

  /* ---------- Démarrage ---------- */
  function init() {
    panel = $('panel'); scrim = $('scrim');
    var pc = $('pclose'); if (pc) pc.addEventListener('click', closeCart);
    if (scrim) scrim.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && panel.classList.contains('on')) closeCart(); });
    var cb = $('cartbtn');
    if (cb && !document.body.classList.contains('tpl-cart')) cb.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    var burger = $('burger'), drawer = $('drawer');
    if (burger && drawer) burger.addEventListener('click', function () { var o = drawer.hidden; drawer.hidden = !o; burger.setAttribute('aria-expanded', String(o)); });
    var sb = $('searchbtn'), sp = $('searchpop');
    if (sb && sp) sb.addEventListener('click', function () { var o = sp.hidden; sp.hidden = !o; sb.setAttribute('aria-expanded', String(o)); if (o) { var q = $('hq'); if (q) q.focus(); } });
    initCards(); initHero(); initProduct(); initAddForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.VC = Object.assign(window.VC || {}, { openCart: openCart, say: say });
})();
